const image = {
    url:"",
    plainText:""
}

export default image;